module.exports = __webpack_public_path__ + "static/img/check-form.aa80eb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/detailed/check-form.svg
// module id = 4IoL
// module chunks = 0